import { render, staticRenderFns } from "./OrderTypeField.vue?vue&type=template&id=685d23ce&scoped=true"
import script from "./OrderTypeField.vue?vue&type=script&lang=js"
export * from "./OrderTypeField.vue?vue&type=script&lang=js"
import style0 from "./OrderTypeField.vue?vue&type=style&index=0&id=685d23ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685d23ce",
  null
  
)

export default component.exports